const fr_FR = {
  'my-annatel': 'Mon Compte',
  'greeting': 'Bonjour',
  'farwell': 'Au revoir',
  'sign-in-to-manage-your-account': 'Bienvenue sur votre espace client',
  'forgot-password': 'Mot de passe oublié?',
  'remember-me': 'Se souvenir de moi',
  'login': 'identifiant',
  'contact-information': 'Coordonnées',
  'name': 'Nom',
  'first-name': 'Prénom',
  'last-name': 'Nom',
  'birth-date': 'Date de naissance',
  'phone': 'Télephone',
  'other-phone': 'Téléphone secondaire',
  'address': 'Adresse',
  'bank-details': 'Coordonnées bancaires',
  'expiration-date': 'Date d’expiration Date',
  'card-holder': 'Titulaire',
  'Actions': 'Actions',
  'change-profile-information': 'Modifier mes informations personelles',
  'change-password': 'Changer le mot de passe',
  'change-payment': 'Ajouter un nouveau moyen de paiement',
  'password': 'Mot de passe',
  'current-password': 'Mot de passe actuel',
  'password-confirmation': 'Confirmation mot de passe',
  'new-password': 'Nouveau mot de passe',
  'enter-current-password': 'Entrez votre mot de passe actuel',
  'enter-new-password': 'Nouveau mot de passe (min. 6 caractères)',
  'confirm-new-password': 'Confirmation mot de passe (min. 6 caractères)',
  'my-personal-information': 'Mes informations personnelles',
  'enter-full-address': 'Entrez votre adresse complète et choisissez la dans la liste qui apparait. Si elle n’apparait pas, merci de cliquer',
  'invoices': 'Mes factures',
  'number': 'Numéro',
  'total': 'Total',
  'includes VAT': 'TTC',
  'personal-information': 'Informations personnelles',
  'contact-details': 'coordonnées',
  'address-not-found-message': 'Entrez votre adresse complète et choisissez la dans la liste qui apparait. Si elle n’apparait pas, merci de cliquer ',
  'right-here': 'ici',
  'cancel': 'Annuler',
  'save': 'Enregistrer',
  'no-changes-to-save': 'Aucun changement à enregistrer',
  'contact-details-have-been-saved': 'Vos informations ont été enregistrées',
  'my-services': 'Mes services',
  'mobile': 'Mobile',
  'land-line': 'Fixe',
  'management-of-my-subscription': 'Gestion de mon abonnement',
  'provider': 'Réseau utilisé',
  'sim-number': 'Numéro de carte SIM',
  'esim-number': 'Numéro eSIM',
  'esim-deleted': 'DESINSTALLÉE',
  'active-esim': 'eSim',
  'help-esim': 'Information eSim',
  'info-esim-on-p1': 'Votre Esim est bien installée sur le mobile et le forfait Annatel est actif.',
  'info-esim-off-p1':'Votre Esim est bien installée, mais la ligne Annatel n’est pas activée sur votre appareil.',
  'info-esim-off-p2':'Pour la réactiver :',
  'info-esim-off-p3':'1. Rendez vous dans Réglages, puis dans Données Cellulaires',
  'info-esim-off-p4':'2. Dans la “Cartes SIM”, choisissez le forfait correspondant à votre ligne Annatel',
  'info-esim-off-p5':'3. Sur la seconde ligne “Activer ce numéro”, passer la pastille en vert',
  'info-esim-deleted-p1':'Vous avez supprimé la Esim Annatel de votre mobile.',
  'info-esim-deleted-p2':"Afin de la réinstaller  il vous suffit de rechercher dans votre boite mail  le message dont l' objet est : [ANNATEL] Réinstallez votre eSIM.",
  'info-esim-deleted-p3':'Dans le mesure ou vous ne le trouvez plus ,veuillez prendre contact avec nos services par Whatsapp :  ',
  'info-esim-deleted-p4':' ',
  'link-whatapp-deleted': 'http://anna.tl/wa',
  'activation-date': "Date d'activation",  
  'other-information': 'Autres informations',
  'active': 'Active',
  'inactive': 'Inactive',
  'virtual-number': 'Numéro virtuel',
  'secondary-numbers': 'Numéro(s) secondaire(s)',
  'current-offer': 'Forfait actuel',
  'more-information': 'Ouvrir le détail',
  'close-information': 'Fermer le détail',
  'freeze-request': 'Demande de freeze',
  'unfreeze-request': 'Demande de défreeze',
  'search-line': 'Rechercher une ligne',
  'Cancel-freeze-message': 'Annuler le freeze actuel',
  'sure-un-freeze-message': 'Etes vous sur de vouloir défreezer votre ligne?',
  'freeze-request-info-message': 'Ce service vous sera facturé 20 shekels par période de 30 jours. Un Freeze ne peut être effectué qu’à partir de votre prochaine date de facturation. La durée minimum d’un Freeze est de 1 mois complet. Le Freeze n\'est pas compatible avec le Mispari. Tout Mispari actif à la date de début du Freeze sera automatiquement résilié.',
  'freeze-selecte-date-last': 'Si vous la connaissez, date de fin de freeze',
  'freeze-request-tv-info-message': 'Un Freeze ne peut être effectué qu’à partir de votre prochaine date de facturation',
  'freeze-selecte-date-first': 'Date de début de freeze',
  'optional': 'optionnel',
  'confirmation-freeze-message': 'Êtes-vous sûr de vouloir freezer le produit à ces dates',
  'call-date': "Date",
  'call-time': "Heure",
  'called-number': 'Numéro appelé',
  'calling-number': 'Numéro appelant',
  'call-duration': "Durée",
  'call-price-excluding-tax': "Cout (HT)",
  'from': 'Du',
  'to': 'au',
  'call-details': 'Détail des appels',
  'manage-my-voicemail': 'Gérer ma messagerie vocale',
  'sending-voice-messages-to-answering-machine': 'envoi de vos messages vocaux vers votre répondeur',
  'important-information': 'Information importante',
  'your-answering-machine': 'Votre messagerie vocale',
  'not-receive-voice-messages-alert': 'Si vous choisissez de ne pas envoyer vos messages vocaux vers votre boite email, vous ne recevrez pas d’alertes. Il vous faudra composer le *151 ou le 0747146543 depuis votre mobile Annatel afin d’écouter vos messages vocaux.',
  'sign-out': 'Déconnexion',
  'consumption': 'Détail des appels',
  'balance': 'Ma consommation',
  'voiceMail': 'Messagerie vocale',
  'roaming': 'Recharge roaming',
  'data': 'Recharge internet',
  'data-prepaid': 'Recharge forfait prépayé',
  'faxReceived': 'Fax Reçus',
  'faxDownload': 'Télécharger mes fax',
  'infiniteMobile': 'Infinite Mobile',
  'createFreeze': 'Freezer',
  'mispariActivate': 'Activer mispari',
  'payment-type': 'Matériel',
  'user-level': 'Niveau d’utilisateur',
  'serial-number': 'Numéro de série',
  'installation-address': "Adresse d'installation",
  'device': 'Appareil',
  'mac_address': 'Adresse MAC',
  'callForward': "renvoi d'appel",
  'displayNumber': "numéro affiché",
  'page-not-available': "Désolé, cette page n'est pas  disponible",
  'insert-email': 'entrez votre email',
  'email-address-receiving-your-voice-messages': 'Adresse emails pour la réception de vos messages vocaux',
  'your-email-has-changed': 'Votre demande a bien été prise en compte',
  'mispari-in-service-since': 'Un Mispari est actif sur cette ligne depuis le',
  'mispariDesactivate': 'Mispari désactivé',
  "no-results": "Aucun résultat",
  'confirm': 'Confirmer',
  'confirmation-message': "Par sécurité, veuillez s'il vous plait confirmer votre demande :",
  'profile': 'Mon Profil',
  'invoice-number': 'Facture N°',
  'invoice-status': 'Status',
  'pay-bill': 'Payer la facture',
  'pay-all-invoices': 'Payer toutes mes factures',
  'go-back-to-the-Annatel-website': 'Accéder au site Annatel',
  'authValidation-message': 'Login ou mot de passe incorrect',
  'freeze-the-line': 'Freeze (suspension) de votre ligne',
  'download': 'Télécharger',
  'details': 'Détails',
  'mispari': 'Modifier Mispari',
  'see-existing-freeze': 'Modification des freezes',
  'information-product-frozen': 'Dates de freeze actuelles :',
  'are-you-sure-unblock': 'Pour remettre la ligne en service, cliquez sur le bouton Defreezer.',
  'select-date': 'Sélectionner une date',
  'Select-date-time-activate-Mispari': 'Sélectionnez la date et l’heure pour activer votre Mispari',
  'mispari-selecte-date-first': 'Date de début du Mispari',
  'mispari-selecte-date-last': 'Date de fin du Mispari',
  'no-active-mispari': 'Aucun service Mispari n’est actif pour cette ligne',
  'change-date-time-activate-Mispari': 'Si vous modifiez cela, veuillez entrer tous les détails ',
  'which-number-forward-calls': 'Choisissez le numéro vers lequel vos appels seront renvoyés',
  'choose-start-date-time-mispari': 'Date et heure du début de votre Mispari',
  'choose-end-date-time-mispari': 'Date et heure de fin de votre Mispari',
  'active-mispari-message': 'Détails de votre Mispari',
  'choose-date-time-of': 'choisissez la date et l’heure de ',
  'end': 'fin',
  'of-your-mispari': 'de votre Mispari',
  'now': 'Maintenant',
  'cancel-the-Mispari': 'Annuler le Mispari prévu',
  'do-you-want-cancel-Mispari': 'Annuler le Mispari prévu',
  'do-not-change': 'Ne pas modifier',
  'change-active-mispari-message': 'Un Mispari est actif sur votre ligne. Vous pouvez modifier la date de fin.',
  'update-mispari-message': 'Modification de votre Mispari',
  'mispari-canceled': 'Mispari a été annulé',
  'change-payment-message': 'Souhaitez vous confirmer votre changement de carte de crédit?',
  'invalid-Credit-Card': 'Carte de crédit invalide',
  'add-payment-method-title': 'ajouter un nouveau moyen de paiement',
  'missing-field': 'Elément manquant ou erroné',
  'Change-language-button': 'Switch to English',
  'fax': 'fax',
  'next-billing-date': 'Prochain cycle de facturation',
  'freeze-request-subtitle': 'Choisissez les dates de freeze (suspension) de votre ligne',
  'un-freeze-button': 'Défreezer',
  'is-in-bundle': 'Dans un pack',
  'no-options-message': 'Pour toute demande concernant ce service, veuillez contacter votre service client au *0555 ou par email à support@annatel.net',
  ////////////******\\\\\\\\\
  'inactives': 'Abonnements Inactifs',
  'activeMobileItems': 'Abonnements Actifs',
  'no-service-header': "Vous ne disposez d'aucun service dans cette catégorie.",
  'no-service-message': 'Pour souscrire à de nouveaux services, contactez votre service client au *0555 depuis Israël ou par email à support@annatel.net',
  'received': 'Reçus',
  'outgoing-calls': 'Emis',
  'missed': 'Manqués',
  'tv-tv': 'TV',
  'without-stopping': 'Sans date de fin',
  'no-voice-mail': '(Messagerie désactivée)',
  'destination': 'Destination',
  'date': 'Date',
  'unfreeze-the-line-confirmation-message': 'Are you sure you want to unfreeze the line?',
  'confirmation-message-title': 'Validation',
  'freeze': 'Freeze',
  'unFreeze': 'Défreezer',
  'internet': 'internet',
  'bundles': 'Packs',
  'contact': 'contact',
  'mispari-start-now': 'Maintenant',
  'mispari-no-end-date': 'Sans date de fin',
  'important-information-message-active-mispari': "Ce service vous sera facturé 20 shekels par période de 30 jours d'utilisation sauf si votre forfait mobile inclut ce service sans supplément. Mispari n'est pas compatible avec le Freeze. Tout Mispari actif à la date de début du Freeze sera automatiquement résilié ou ne sera pas activé.",
  'successfully-connected-message': 'Bienvenue sur votre Espace Client Annatel',
  'call-details-subtitle': 'Sélectionnez une période afin de consulter le détail de vos appels',
  'street-name': 'Rue',
  'house-number': 'Numéro (Immeuble)',
  'apartment-number': 'Numéro (Appartement)',
  'city': 'Ville',
  'country': 'Pays',
  'postcode': 'Code postal',
  'entrance': 'Entrée',

  'beta-message': 'Espace Client : Si certaines fonctions ne sont pas présentes sur cette nouvelle version, utilisez la version 1 en ',
  'beta-link': 'cliquant ici',
  'start-date': 'Date de début',
  'end-date': 'Date de fin',
  'date-not-available': 'Non renseignée',
  'changes-saved-successfully': 'Les modifications ont bien été prises en compte',
  'changes-failed': 'Les modifications ont échoué',
  'un-freeze-the-line': 'Defreezer la ligne',
  'call-details-go-button': 'Go',
  'lignes-inactives': 'Lignes inactives',

  'confirmation-update-mispari-message': 'Modification de votre Mispari',
  'confirmation-change-active-mispari-message': 'Modification de votre Mispari',
  'confirmation-active-mispari-message': 'Activation de votre Mispari',
  'login-button': 'Se connecter',
  'start-now-option': 'Maintenant',
  'no-end-date-option': 'Sans date de fin',
  'current-mispari-number': 'Numéro de renvoi actuel :',
  'teudat-zeut': 'Teoudat Zeout',
  'must-be-a-number': 'Chiffres uniquement',
  'update-freeze-subtitle': 'Modifiez votre freeze ci-dessous: ',
  'do-you-want-cancel-freeze': 'Cliquez pour annuler le freeze prévu',
  'cancel-the-freeze-button': 'Annuler le freeze prévu',
  'freeze-no-end-date': 'Sans date de fin',
  'do-you-want-cancel-freeze-confirmation-message': 'Vous souhaitez annuler le freeze prévu sur votre ligne',
  'on-phone-number': 'Sur la ligne',
  'change-existing-mispari': 'Modifier le Mispari',
  'start-mispari': 'Activer Mispari',
  'mispari-option-when-line-is-frozen': 'Activer Mispari (indisponible en freeze)',
  'change-profile-address-information': 'Modifier mon adresse',
  'change-address-title': 'Adresse',
  'enter-adress-placeholder': 'veuillez entrer votre adresse',
  'password-not-match-confirm-password': 'Les mots de passent ne correspondent pas',
  'password-length-error': 'Votre mot de passe doit comprendre au moins 6 caractères',
  'password-changed-successfully': 'Votre mot de passe a été mis à jour',
  'update-ongoing-freeze': 'Vous souhaitez modifier le freeze en cours de votre ligne',
  'cancel-ongoing-freeze': 'Vous souhaitez mettre fin au freeze de votre ligne',
  'update-upcoming-freeze': 'Vous souhaitez modifier le freeze prévu sur votre ligne',
  'pay-now-button': 'Payer',
  'pay-now-confirm-message': 'Vous vous apprêtez à payer les facture suivantes',
  'invoice-id': 'N° de Facture',
  'failed-attempt-payment': 'Failed to attempt payment',
  'pending-activation': 'En attente d\'activation',
  'upgrade-update-on': 'Changement de forfait planifié pour le ',
  'upgrade-to': ' vers ',
  'activate-my-line': 'J\'active ma ligne',
  'awaiting-migration': 'En attente de migration',
  'activation-in-progress': 'En cours d\'activation',
  'apn-filter': 'Filtre internet',
  'activate-apn-filter': 'Activer le filtre internet ?',
  'warning-apn-title': 'Information importante : ',
  'warning-apn-text': 'Afin de modifier le statut du filtre, redémarrez le téléphone 5 minutes après avoir validé cette page.',

  // Used for call details description
  'call_in': 'Appel en',
  'sms_in': 'SMS en',
  'call_roaming': 'Appel roaming',
  '_to_': ' vers ',
  'has-future-freeze': 'Freeze prévu',
  'end-of-freeze-planned-on': 'Fin du freeze prévue le',
  'has-active-mispari': 'Mispari actif',
  'mispari-ends-on': ' jusqu\'au',
  'mispari-planned': 'Mispari prévu',
  'mispari-forward-to': ' vers le ',
  'mispari-without-end-planned-on': ' à partir du ',
  'mispari-with-end-planned-on': ' du ',
  'mispari-planned-until': ' au ',
  'end-of-current-mispari-planned-on': 'Fin du mispari en cours prévue le',
  'login-or-password-incorrect': 'Login ou password incorrectes'
};
export default fr_FR;



// WEBPACK FOOTER //
// ./src/localeAssets/fr.js